// -------------- Hook to call the api endpoint for the backtesting -----------------
// ----------------------------------------------------------------------------------
import { useState, useCallback } from 'react';
import { getModelPredictions } from '../services/api';

// Custom hook to handle backtesting API calls
export const useBacktest = () => {

  // create state variables for result, loading, and error
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // function to run the backtest by calling the API with the provided parameters
  const runBacktest = useCallback(async ({ model, timeframe, k_long, k_short, date_from, date_to }) => {
    // set the state to be loading and others to null
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      // call the API to get model predictions and set the result state variable with the response
      const data = await getModelPredictions({ model, timeframe, k_long, k_short, date_from, date_to });
      setResult(data);

    } catch (err) { // catch any errors that occur during the API call and set the error state variable with the error message
      console.error('Error running backtest:', err);
      setError(err.message || 'Failed to run backtest');

    } finally { // no matter what set the loading to false
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => { // function to reset the state variables to their initial values
    setResult(null);
    setError(null);
  }, []);

  return { result, loading, error, runBacktest, reset };
};
